import { Box } from "@mui/material";
import {
  DEFAULT_USER_SRC,
  replaceUnderScoreAddSpace,
} from "../../../../../utils/utils";
import Flex from "../../../../Flex";
import Text from "../../../../Text";
import { DSTag } from "../../../../ds/DSTag";

export const SavedCards = ({
  cards,
  selectedCard,
  onSelect,
}: {
  cards: any[];
  selectedCard: (typeof cards)[number];
  onSelect: (v: (typeof cards)[number]) => void;
}) => {
  return cards?.map((it) => (
    <Flex
      key={it?.paymentMethodId}
      justifyContent={"center"}
      flexDirection={"column"}
      height={"8.686rem"}
      width={"14.5rem"}
      bgcolor={"#FAFAFA"}
      borderRadius={3}
      p={2}
      gap={1}
      sx={{ cursor: "pointer" }}
      border={`2px solid  ${
        selectedCard?.paymentMethodId === it?.paymentMethodId
          ? "#004186"
          : "#FAFAFA"
      }`}
      onClick={() => onSelect(it)}
    >
      <Flex
        justifyContent={"space-between"}
        alignItems={"center"}
        width={"100%"}
      >
        <Box
          sx={{
            height: "30px",
            width: "30px",
          }}
        >
          <img src={DEFAULT_USER_SRC} alt="card-img" />
        </Box>
        {it?.primary && <DSTag label="Primary" active />}
      </Flex>
      <Text fontSize={"18px"}>
        **** &nbsp;&nbsp; **** &nbsp;&nbsp; **** &nbsp;&nbsp; {it?.last4}
      </Text>
      {/* {it?.id?.slice(0, 4)} */}
      {it?.displayBrand ? replaceUnderScoreAddSpace(it?.displayBrand) : ""}
    </Flex>
  ));
};
